import { ActionEdit, ActionReply, BasicComments, Comment, ComposerAndComments } from 'component/comment';
import { ActionUpvote } from 'feature/comments/upvote';
import { getPinCommentActions } from 'feature/question/pin-comment';
import { getPinReplyActions } from 'feature/question/pin-reply';
import { CLICK, component, componentWithVariants, demoFile, INPUT, POPUP, story, variant, WITHIN } from 'system/demo';

demoFile('component/comment');

const collections = {
    comment: [
        { key: 1, from: 'a', text: 'I love this movie!' },
        {
            key: 2,
            from: 'b',
            text: 'My comment is very long.\nMy comment is very long.\nMy comment is very long.\nMy comment is very long.\nMy comment is very long.\nMy comment is very long.\nMy comment is very long.\nMy comment is very long.\nMy comment is very long.\nMy comment is very long.\nMy comment is very long.\nMy comment is very long.\nMy comment is very long.',
        },
        { key: 3, from: 'c', replyTo: 1, text: 'I think this movie is okay.' },
        { key: 4, from: 'a', replyTo: 2, text: 'This reply should be shown' },
        { key: 5, from: 'e', text: 'Comment with no replies' },
    ],
};

const config = {
    commentActions: [ActionReply, ActionUpvote],
    commentRightActions: [ActionEdit],
    commentAdminActions: [getPinCommentActions, getPinReplyActions],
};

component(
    'ComposerAndComments',
    ComposerAndComments,
    {
        args: { commentKey: 'new' },
    },
    [story('Write comment', [INPUT('comment-edit', 'This is my comment'), CLICK('Post')])],
);

componentWithVariants('Comment', Comment, {}, [
    variant(
        null,
        {
            args: { commentKey: '2' },
            config,
            state: {
                collections,
                roles: [],
                sessionData: { 'showReplies/2': true },
            },
        },
        [
            story('Edit Reply', [CLICK('Edit'), INPUT('comment-edit', 'Edited Comment'), CLICK('Update')]),
            story('Cancel Editing Reply', [CLICK('Edit'), CLICK('Cancel')]),
            story('Delete Reply', [CLICK('Edit'), CLICK('delete'), POPUP(CLICK('confirm-delete'))]),
            story('Hide Replies', [CLICK('toggle-replies')]),
            story('Read More', [CLICK('Read more')]),
            story('Go to profile', [CLICK('Bob Bauer')]),
        ],
    ),
    variant(
        'Logged Out',
        {
            args: { commentKey: '5' },
            config,
            state: { collections, personaKey: null },
        },
        [story('Login to Reply', [CLICK('Reply')]), story('Login to Upvote', [CLICK('upvote')])],
    ),
    variant(
        'Admin',
        {
            args: { commentKey: '1' },
            config,
            state: {
                collections,
                roles: ['Owner'],
                sessionData: { 'showReplies/1': true },
            },
        },
        [story('Show Admin Actions', [CLICK('admin-1')]), story('Feature Comment', [CLICK('admin-1'), POPUP(CLICK('Feature'))])],
    ),
]);

component('BasicComments', BasicComments, {
    state: { collections },
    config: {
        noMoreCommentsMessage: 'No more comments',
        commentInputPlaceholder: 'Share your thoughts...',
    },
});
